module.exports = __webpack_public_path__ + "static/media/AA-Fish_normal.8d8dd63e.png";